import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
import styles from './Skeleton.module.css';
/** §0.5 loading placeholder — shaped like the content it stands in for.
 * Never a blank frame, never a bare spinner where a skeleton fits. */
export function Skeleton({ shape = 'text-line', width, height, className, count = 1 }) {
    const style = {
        ...(width !== undefined ? { '--skeleton-w': width } : {}),
        ...(height !== undefined ? { '--skeleton-h': height } : {}),
    };
    return (_jsx("span", { className: styles['group'], "aria-hidden": "true", children: Array.from({ length: count }, (_, index) => (_jsx("span", { className: cn(styles['skeleton'], styles[shape], className), style: style }, index))) }));
}
